module.exports = __webpack_public_path__ + "img/logo_header_pro.94eb1dad.svg";